import { createContext, useContext } from 'react';
import { TRANSLATIONS_NAMESPACE } from '@wix/app-installer/internal-use';
export const TranslationsContext = /*#__PURE__*/createContext({
  i18n: {},
  t: () => '',
  ns: TRANSLATIONS_NAMESPACE
});
export const useLibraryTranslations = () => useContext(TranslationsContext);
//# sourceMappingURL=TranslationsContext.js.map